import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Link, useLocation } from "react-router-dom";

const LINKS = [
  { to: "/#studio", label: "About" },
  { to: "/#team", label: "Work" },
  { to: "/#contact", label: "Contact" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const logoHome = pathname === "/" ? "/#top" : "/";

  return (
    <motion.header
      initial={{ y: -30, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
      data-testid="site-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-[background,backdrop-filter,border-color] duration-300 ${
        scrolled
          ? "bg-[rgba(245,241,232,0.78)] backdrop-blur-md border-b border-[color:var(--collab-hairline)]"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="shell flex items-center justify-between py-5">
        <Link
          to={logoHome}
          data-testid="nav-logo"
          className="flex items-center"
          aria-label="COLLAB Experiential"
        >
          <img
            src="/logos/collab_dark_t.png"
            alt="COLLAB Experiential"
            className="h-8 md:h-9 w-auto select-none"
            draggable="false"
          />
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="font-mono text-[22px] uppercase tracking-[0.2em] text-[color:var(--collab-ink)] hover:text-[color:var(--collab-forest)] transition-colors"
            >
              {l.label}
            </Link>
          ))}
        </nav>

        <Link
          to="/#contact"
          data-testid="nav-cta"
          className="hidden md:inline-flex font-mono text-[11px] uppercase tracking-[0.2em] px-4 py-2 border border-[color:var(--collab-ink)] hover:bg-[color:var(--collab-ink)] hover:text-[color:var(--collab-cream)] transition-colors"
        >
          Start a project →
        </Link>

        <Link
          to="/#contact"
          data-testid="nav-cta-mobile"
          className="md:hidden font-mono text-[11px] uppercase tracking-[0.2em]"
        >
          Contact →
        </Link>
      </div>
    </motion.header>
  );
}
